//Calculate Start Time-
// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import moment from "moment";
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   DirectionsRenderer,
//   InfoWindow,
//   OverlayView,
// } from "@react-google-maps/api";
// import Layouts from "../../layouts/layouts";

// const containerStyle = {
//   width: "100vw",
//   height: "100vh",
//   position: "absolute",
//   top: 0,
//   left: 0,
// };

// const rippleStyle = {
//   position: "absolute",
//   width: "200px",
//   height: "200px",
//   background: "#4285F4",
//   borderRadius: "50%",
//   animation: "ripple 1.5s infinite",
//   transform: "translate(-50%, -50%)",
//   opacity: 0.4,
// };

// const keyframes = `
//   @keyframes ripple {
//     0% {
//       transform: translate(-50%, -50%) scale(0.3);
//       opacity: 0.6;
//     }
//     100% {
//       transform: translate(-50%, -50%) scale(1.4);
//       opacity: 0;
//     }
//   }
// `;

// // Haversine formula to calculate distance between two coordinates
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const toRad = (value) => (value * Math.PI) / 180;
//   const R = 6371; // Earth radius in KM
//   const dLat = toRad(lat2 - lat1);
//   const dLon = toRad(lon2 - lon1);

//   const a =
//     Math.sin(dLat / 2) ** 2 +
//     Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// export default function Tracking() {
//   const { id } = useParams();
//   const location = useLocation();
//   const mapRef = useRef(null);

//   const [pathCoordinates, setPathCoordinates] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(
//     location.state?.date || new Date().toISOString().slice(0, 10)
//   );
//   const [selectedMarker, setSelectedMarker] = useState(null);
//   const [directions, setDirections] = useState(null);
//   const [noTrackingMessage, setNoTrackingMessage] = useState("");
//   const [totalDistance, setTotalDistance] = useState(0);
//   const [firstMovementTime, setFirstMovementTime] = useState(null);
//   const [firstMovementCoords, setFirstMovementCoords] = useState(null);

//   useEffect(() => {
//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = keyframes;
//     document.head.appendChild(styleSheet);
//   }, []);

//   useEffect(() => {
//     const { date } = location.state || {};
//     if (date) {
//       setSelectedDate(date);
//       fetchVehicleData(date);
//     }
//   }, [location.state]);

//   const splitIntoChunks = (coords, maxPoints = 25) => {
//     const chunks = [];
//     for (let i = 0; i < coords.length - 1; i += maxPoints - 1) {
//       const chunk = coords.slice(i, i + maxPoints);
//       if (chunk.length < 2) break;
//       chunks.push(chunk);
//     }
//     return chunks;
//   };

//   const calculateTotalDistance = (coords) => {
//     let distance = 0;
//     for (let i = 0; i < coords.length - 1; i++) {
//       const from = coords[i];
//       const to = coords[i + 1];
//       distance += calculateDistance(from.lat, from.lng, to.lat, to.lng);
//     }
//     setTotalDistance(distance);
//   };

//   const fetchVehicleData = async () => {
//     try {
//       setLoading(true);
//       setNoTrackingMessage("");
//       const token = localStorage.getItem("token");
//       if (!token) {
//         console.error("No token found");
//         return;
//       }

//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/vehicleHistory/vehicle/${id}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const locationData = response.data.vehicleHistory || [];

//       // Filter for selected date
//       const sameDayRecords = locationData
//         .filter(
//           (loc) => moment(loc.lastDate).format("YYYY-MM-DD") === selectedDate
//         )
//         .sort((a, b) => new Date(a.lastDate) - new Date(b.lastDate));

//       // Detect first movement
//       // Detect first movement
//       const firstMovement = sameDayRecords.find(
//         (rec) =>
//           rec.vehicleStatus?.toLowerCase() === "running" ||
//           parseFloat(rec.speed) > 0
//       );

//       if (firstMovement) {
//         setFirstMovementTime(moment(firstMovement.lastDate).format("h:mm a")); // <-- 12-hour format
//         if (
//           firstMovement.coordinates &&
//           firstMovement.coordinates.latitude &&
//           firstMovement.coordinates.longitude
//         ) {
//           setFirstMovementCoords({
//             lat: parseFloat(firstMovement.coordinates.latitude),
//             lng: parseFloat(firstMovement.coordinates.longitude),
//           });
//         }
//       } else {
//         setFirstMovementTime(null);
//         setFirstMovementCoords(null);
//       }

//       // Map to coordinates for path
//       const filteredCoordinates = sameDayRecords
//         .map((location) => {
//           if (
//             location.coordinates &&
//             location.coordinates.latitude &&
//             location.coordinates.longitude
//           ) {
//             return {
//               lat: parseFloat(location.coordinates.latitude),
//               lng: parseFloat(location.coordinates.longitude),
//               locationName: location.location || "Unknown location",
//             };
//           }
//           return null;
//         })
//         .filter((coord) => coord !== null);

//       if (filteredCoordinates.length === 0) {
//         setPathCoordinates([]);
//         setTotalDistance(0);
//         setNoTrackingMessage("NO TRACKING AVAILABLE FOR TODAY");
//         return;
//       }

//       setPathCoordinates(filteredCoordinates);
//       calculateTotalDistance(filteredCoordinates);
//     } catch (error) {
//       console.error("Error fetching vehicle data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehicleData();
//   }, []);

//   useEffect(() => {
//     if (pathCoordinates.length > 1) {
//       fetchDirections(pathCoordinates);
//     }
//   }, [pathCoordinates]);

//   const fetchDirections = async (coordinates) => {
//     if (coordinates.length < 2) return;

//     const chunks = splitIntoChunks(coordinates);
//     const directionsService = new window.google.maps.DirectionsService();
//     const directionResults = [];

//     for (const chunk of chunks) {
//       const origin = chunk[0];
//       const destination = chunk[chunk.length - 1];
//       const waypoints = chunk.slice(1, -1).map((coord) => ({
//         location: { lat: coord.lat, lng: coord.lng },
//         stopover: false,
//       }));

//       await new Promise((resolve) => {
//         directionsService.route(
//           {
//             origin,
//             destination,
//             waypoints,
//             travelMode: window.google.maps.TravelMode.DRIVING,
//           },
//           (result, status) => {
//             if (status === window.google.maps.DirectionsStatus.OK) {
//               directionResults.push(result);
//             } else {
//               console.error("Error fetching directions:", status);
//             }
//             resolve();
//           }
//         );
//       });
//     }

//     setDirections(directionResults);
//   };

//   const handleMarkerClick = (marker) => {
//     setSelectedMarker(marker);
//   };

//   const handleInfoWindowCloseClick = () => {
//     setSelectedMarker(null);
//   };

//   return (
//     <>
//       <Layouts />
//       <div
//         style={{
//           position: "absolute",
//           top: "13px",
//           right: "70px",
//           zIndex: 1000,
//           background: "rgba(255, 255, 255, 0.25)",
//           backdropFilter: "blur(8px)",
//           WebkitBackdropFilter: "blur(8px)",
//           border: "1px solid rgba(255, 255, 255, 0.3)",
//           borderRadius: "8px",
//           padding: "12px 24px",
//           color: "#000",
//           fontSize: "17px",
//           fontWeight: "600",
//           boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
//           transition: "all 0.3s ease",
//           backgroundColor: "#f8b333ff",
//         }}
//       >
//         🚗 Total Distance:{" "}
//         <span style={{ color: "#00796b" }}>{totalDistance.toFixed(2)} km</span>
//         {firstMovementTime && (
//           <div style={{ marginTop: "5px", fontSize: "15px" }}>
//             🕒 First Movement:{" "}
//             <span style={{ color: "#00796b" }}>{firstMovementTime}</span>
//           </div>
//         )}
//       </div>

//       <LoadScript googleMapsApiKey={process.env.REACT_APP_BASE_API}>
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={pathCoordinates[0] || { lat: 30.7067034, lng: 76.6877915 }}
//           zoom={12}
//           onLoad={(map) => (mapRef.current = map)}
//         >
//           {loading ? (
//             <div>Loading...</div>
//           ) : noTrackingMessage ? (
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%)",
//                 backgroundColor: "#ffdddd",
//                 padding: "10px 20px",
//                 borderRadius: "10px",
//                 fontSize: "18px",
//                 fontWeight: "bold",
//                 color: "#d9534f",
//               }}
//             >
//               {noTrackingMessage}
//             </div>
//           ) : (
//             <>
//               {pathCoordinates.length > 0 && (
//                 <OverlayView
//                   position={pathCoordinates[pathCoordinates.length - 1]}
//                   mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
//                 >
//                   <div style={rippleStyle}></div>
//                 </OverlayView>
//               )}

//               {/* Special marker for first movement */}
//               {firstMovementCoords && (
//                 <Marker
//                   position={firstMovementCoords}
//                   icon={{
//                     url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
//                   }}
//                   title="First Movement of the Day"
//                 />
//               )}

//               {directions &&
//                 directions.map((dir, idx) => (
//                   <DirectionsRenderer key={idx} directions={dir} />
//                 ))}

//               {selectedMarker && (
//                 <InfoWindow
//                   position={selectedMarker}
//                   onCloseClick={handleInfoWindowCloseClick}
//                 >
//                   <div>
//                     <h4>{selectedMarker.locationName}</h4>
//                     <p>
//                       Coordinates: {selectedMarker.lat}, {selectedMarker.lng}
//                     </p>
//                   </div>
//                 </InfoWindow>
//               )}
//             </>
//           )}
//         </GoogleMap>
//       </LoadScript>
//     </>
//   );
// }

// const fetchVehicleData = async () => {
//   try {
//     setLoading(true);
//     setNoTrackingMessage("");
//     const token = localStorage.getItem("token");
//     if (!token) {
//       console.error("No token found");
//       return;
//     }

//     const response = await axios.get(
//       `${process.env.REACT_APP_BASE_URL}/api/v1/vehicleHistory/vehicle/${id}`,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     const locationData = response.data.vehicleHistory || [];

//     // Filter for selected date
//     const sameDayRecords = locationData
//       .filter(
//         (loc) => moment(loc.lastDate).format("YYYY-MM-DD") === selectedDate
//       )
//       .sort((a, b) => new Date(a.lastDate) - new Date(b.lastDate));

//     // Detect first movement
//     // Detect first movement
//     const firstMovement = sameDayRecords.find(
//       (rec) =>
//         rec.vehicleStatus?.toLowerCase() === "running" ||
//         parseFloat(rec.speed) > 0
//     );

//     if (firstMovement) {
//       setFirstMovementTime(moment(firstMovement.lastDate).format("h:mm a")); // <-- 12-hour format
//       if (
//         firstMovement.coordinates &&
//         firstMovement.coordinates.latitude &&
//         firstMovement.coordinates.longitude
//       ) {
//         setFirstMovementCoords({
//           lat: parseFloat(firstMovement.coordinates.latitude),
//           lng: parseFloat(firstMovement.coordinates.longitude),
//         });
//       }
//     } else {
//       setFirstMovementTime(null);
//       setFirstMovementCoords(null);
//     }

//     // Map to coordinates for path
//     const filteredCoordinates = sameDayRecords
//       .map((location) => {
//         if (
//           location.coordinates &&
//           location.coordinates.latitude &&
//           location.coordinates.longitude
//         ) {
//           return {
//             lat: parseFloat(location.coordinates.latitude),
//             lng: parseFloat(location.coordinates.longitude),
//             locationName: location.location || "Unknown location",
//           };
//         }
//         return null;
//       })
//       .filter((coord) => coord !== null);

//     if (filteredCoordinates.length === 0) {
//       setPathCoordinates([]);
//       setTotalDistance(0);
//       setNoTrackingMessage("NO TRACKING AVAILABLE FOR TODAY");
//       return;
//     }

//     setPathCoordinates(filteredCoordinates);
//     // calculateTotalDistance(filteredCoordinates);
//   } catch (error) {
//     console.error("Error fetching vehicle data:", error);
//   } finally {
//     setLoading(false);
//   }
// };

// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useLocation } from "react-router-dom";
// import axios from "axios";
// import moment from "moment";
// import {
//   GoogleMap,
//   LoadScript,
//   Marker,
//   DirectionsRenderer,
//   InfoWindow,
//   OverlayView,
// } from "@react-google-maps/api";
// import Layouts from "../../layouts/layouts";

// const containerStyle = {
//   width: "100vw",
//   height: "100vh",
//   position: "absolute",
//   top: 0,
//   left: 0,
// };

// const rippleStyle = {
//   position: "absolute",
//   width: "200px",
//   height: "200px",
//   background: "#4285F4",
//   borderRadius: "50%",
//   animation: "ripple 1.5s infinite",
//   transform: "translate(-50%, -50%)",
//   opacity: 0.4,
// };

// const keyframes = `
//   @keyframes ripple {
//     0% {
//       transform: translate(-50%, -50%) scale(0.3);
//       opacity: 0.6;
//     }
//     100% {
//       transform: translate(-50%, -50%) scale(1.4);
//       opacity: 0;
//     }
//   }
// `;

// // Haversine formula to calculate distance between two coordinates
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const toRad = (value) => (value * Math.PI) / 180;
//   const R = 6371; // Earth radius in KM
//   const dLat = toRad(lat2 - lat1);
//   const dLon = toRad(lon2 - lon1);

//   const a =
//     Math.sin(dLat / 2) ** 2 +
//     Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// export default function Tracking() {
//   const { id } = useParams();
//   const location = useLocation();
//   const mapRef = useRef(null);

//   const [pathCoordinates, setPathCoordinates] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(
//     location.state?.date || new Date().toISOString().slice(0, 10)
//   );
//   const [selectedMarker, setSelectedMarker] = useState(null);
//   const [directions, setDirections] = useState(null);
//   const [noTrackingMessage, setNoTrackingMessage] = useState("");
//   const [totalDistance, setTotalDistance] = useState(0);
//   const [firstMovementTime, setFirstMovementTime] = useState(null);
//   const [firstMovementCoords, setFirstMovementCoords] = useState(null);
//   const [lastMovementTime, setLastMovementTime] = useState(null);

//   useEffect(() => {
//     const styleSheet = document.createElement("style");
//     styleSheet.type = "text/css";
//     styleSheet.innerText = keyframes;
//     document.head.appendChild(styleSheet);
//   }, []);

//   useEffect(() => {
//     const { date } = location.state || {};
//     if (date) {
//       setSelectedDate(date);
//       fetchVehicleData(date);
//     }
//   }, [location.state]);

//   const splitIntoChunks = (coords, maxPoints = 23) => {
//     const chunks = [];
//     for (let i = 0; i < coords.length - 1; i += maxPoints - 1) {
//       const chunk = coords.slice(i, i + maxPoints);
//       if (chunk.length < 2) break;
//       chunks.push(chunk);
//     }
//     return chunks;
//   };

//   const calculateTotalDistance = (coords) => {
//     let distance = 0;
//     for (let i = 0; i < coords.length - 1; i++) {
//       const from = coords[i];
//       const to = coords[i + 1];
//       distance += calculateDistance(from.lat, from.lng, to.lat, to.lng);
//     }
//     setTotalDistance(distance);
//   };

//   const fetchVehicleData = async (date = selectedDate) => {
//     try {
//       setLoading(true);
//       setNoTrackingMessage("");
//       const token = localStorage.getItem("token");
//       if (!token) {
//         console.error("No token found");
//         return;
//       }

//       // ✅ Now pass vehicleId + selectedDate directly
//       const response = await axios.get(
//         `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-history/${id}/${date}`,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       const locationData = response.data.vehicleHistory || [];

//       if (!locationData.length) {
//         setPathCoordinates([]);
//         setTotalDistance(0);
//         setNoTrackingMessage("NO TRACKING AVAILABLE FOR TODAY");
//         return;
//       }

//       // Detect first movement (running/speed > 0)
//       const firstMovement = locationData.find(
//         (rec) =>
//           rec.vehicleStatus?.toLowerCase() === "running" ||
//           parseFloat(rec.speed) > 0
//       );

//       if (firstMovement) {
//         setFirstMovementTime(moment(firstMovement.lastDate).format("h:mm a"));
//         if (
//           firstMovement.coordinates?.latitude &&
//           firstMovement.coordinates?.longitude
//         ) {
//           setFirstMovementCoords({
//             lat: parseFloat(firstMovement.coordinates.latitude),
//             lng: parseFloat(firstMovement.coordinates.longitude),
//           });
//         }
//       } else {
//         setFirstMovementTime(null);
//         setFirstMovementCoords(null);
//       }

//       const lastMovement = [...locationData]
//         .reverse()
//         .find(
//           (rec) =>
//             rec.vehicleStatus?.toLowerCase() === "running" ||
//             parseFloat(rec.speed) > 0
//         );

//       if (lastMovement) {
//         setLastMovementTime(moment(lastMovement.lastDate).format("h:mm a"));
//       } else {
//         setLastMovementTime(null);
//       }
//       // Map coordinates
//       const filteredCoordinates = locationData
//         .map((location) => {
//           if (
//             location.coordinates?.latitude &&
//             location.coordinates?.longitude
//           ) {
//             return {
//               lat: parseFloat(location.coordinates.latitude),
//               lng: parseFloat(location.coordinates.longitude),
//               locationName: location.location || "Unknown location",
//             };
//           }
//           return null;
//         })
//         .filter(Boolean);

//       setPathCoordinates(filteredCoordinates);
//     } catch (error) {
//       console.error("Error fetching vehicle data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehicleData();
//   }, []);

//   useEffect(() => {
//     if (pathCoordinates.length > 1) {
//       fetchDirections(pathCoordinates);
//     }
//   }, [pathCoordinates]);

//   const fetchDirections = async (coordinates) => {
//     if (coordinates.length < 2) return;

//     const chunks = splitIntoChunks(coordinates, 23); // 👈 break into groups of 23
//     const directionsService = new window.google.maps.DirectionsService();
//     const directionResults = [];
//     let total = 0;

//     for (const chunk of chunks) {
//       const origin = chunk[0];
//       const destination = chunk[chunk.length - 1];
//       const waypoints = chunk.slice(1, -1).map((coord) => ({
//         location: { lat: coord.lat, lng: coord.lng },
//         stopover: false,
//       }));

//       await new Promise((resolve) => {
//         directionsService.route(
//           {
//             origin,
//             destination,
//             waypoints,
//             travelMode: window.google.maps.TravelMode.DRIVING,
//           },
//           (result, status) => {
//             if (status === window.google.maps.DirectionsStatus.OK) {
//               directionResults.push(result);

//               // 👇 sum up all leg distances
//               const legs = result.routes[0].legs;
//               legs.forEach((leg) => {
//                 total += leg.distance.value; // meters
//               });
//             } else {
//               console.error("Error fetching directions:", status);
//             }
//             resolve();
//           }
//         );
//       });
//     }

//     setDirections(directionResults);
//     setTotalDistance(total / 1000); // convert meters → km
//   };

//   const handleMarkerClick = (marker) => {
//     setSelectedMarker(marker);
//   };

//   const handleInfoWindowCloseClick = () => {
//     setSelectedMarker(null);
//   };

//   return (
//     <>
//       <Layouts />
//       <div
//         style={{
//           position: "absolute",
//           top: "13px",
//           right: "70px",
//           zIndex: 1000,
//           background: "rgba(255, 255, 255, 0.25)",
//           backdropFilter: "blur(8px)",
//           WebkitBackdropFilter: "blur(8px)",
//           border: "1px solid rgba(255, 255, 255, 0.3)",
//           borderRadius: "8px",
//           padding: "12px 24px",
//           color: "#000",
//           fontSize: "17px",
//           fontWeight: "600",
//           boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
//           transition: "all 0.3s ease",
//           backgroundColor: "#f8b333ff",
//         }}
//       >
//         🚗 Total Distance:{" "}
//         <span style={{ color: "#00796b" }}>{totalDistance.toFixed(2)} km</span>
//         {firstMovementTime && (
//           <div style={{ marginTop: "5px", fontSize: "15px" }}>
//             🕒 First Movement:{" "}
//             <span style={{ color: "#00796b" }}>{firstMovementTime}</span>
//           </div>
//         )}
//       </div>

//       <LoadScript googleMapsApiKey={process.env.REACT_APP_BASE_API}>
//         <GoogleMap
//           mapContainerStyle={containerStyle}
//           center={pathCoordinates[0] || { lat: 30.7067034, lng: 76.6877915 }}
//           zoom={12}
//           onLoad={(map) => (mapRef.current = map)}
//         >
//           {loading ? (
//             <div>Loading...</div>
//           ) : noTrackingMessage ? (
//             <div
//               style={{
//                 position: "absolute",
//                 top: "50%",
//                 left: "50%",
//                 transform: "translate(-50%, -50%)",
//                 backgroundColor: "#ffdddd",
//                 padding: "10px 20px",
//                 borderRadius: "10px",
//                 fontSize: "18px",
//                 fontWeight: "bold",
//                 color: "#d9534f",
//               }}
//             >
//               {noTrackingMessage}
//             </div>
//           ) : (
//             <>
//               {pathCoordinates.length > 0 && (
//                 <OverlayView
//                   position={pathCoordinates[pathCoordinates.length - 1]}
//                   mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
//                 >
//                   <div style={rippleStyle}></div>
//                 </OverlayView>
//               )}

//               {/* Special marker for first movement */}
//               {firstMovementCoords && (
//                 <Marker
//                   position={firstMovementCoords}
//                   icon={{
//                     url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
//                   }}
//                   title="First Movement of the Day"
//                 />
//               )}

//               {directions &&
//                 directions.map((dir, idx) => (
//                   <DirectionsRenderer key={idx} directions={dir} />
//                 ))}

//               {selectedMarker && (
//                 <InfoWindow
//                   position={selectedMarker}
//                   onCloseClick={handleInfoWindowCloseClick}
//                 >
//                   <div>
//                     <h4>{selectedMarker.locationName}</h4>
//                     <p>
//                       Coordinates: {selectedMarker.lat}, {selectedMarker.lng}
//                     </p>
//                   </div>
//                 </InfoWindow>
//               )}
//             </>
//           )}
//         </GoogleMap>
//       </LoadScript>
//     </>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import {
  GoogleMap,
  LoadScript,
  Marker,
  DirectionsRenderer,
  InfoWindow,
  OverlayView,
} from "@react-google-maps/api";
import Layouts from "../../layouts/layouts";

const containerStyle = {
  width: "100vw",
  height: "100vh",
  position: "absolute",
  top: 0,
  left: 0,
};

const rippleStyle = {
  position: "absolute",
  width: "200px",
  height: "200px",
  background: "#4285F4",
  borderRadius: "50%",
  animation: "ripple 1.5s infinite",
  transform: "translate(-50%, -50%)",
  opacity: 0.4,
};

const keyframes = `
  @keyframes ripple {
    0% {
      transform: translate(-50%, -50%) scale(0.3);
      opacity: 0.6;
    }
    100% {
      transform: translate(-50%, -50%) scale(1.4);
      opacity: 0;
    }
  }
`;

// Haversine formula to calculate distance between two coordinates
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371; // Earth radius in KM
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export default function Tracking() {
  const { id } = useParams();
  const location = useLocation();
  const mapRef = useRef(null);
  const [hubNames, setHubNames] = useState([]);

  const [pathCoordinates, setPathCoordinates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    location.state?.date || new Date().toISOString().slice(0, 10)
  );
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [directions, setDirections] = useState(null);
  const [noTrackingMessage, setNoTrackingMessage] = useState("");
  const [totalDistance, setTotalDistance] = useState(0);
  const [firstMovementTime, setFirstMovementTime] = useState(null);
  const [firstMovementCoords, setFirstMovementCoords] = useState(null);
  const [lastMovementTime, setLastMovementTime] = useState(null);
  const [lastMovementLocation, setLastMovementLocation] = useState(null);
  const [vehicleNumber, setVehicleNumber] = useState(null);

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = keyframes;
    document.head.appendChild(styleSheet);
  }, []);

  useEffect(() => {
    const { date } = location.state || {};
    if (date) {
      setSelectedDate(date);
      fetchVehicleData(date);
    }
  }, [location.state]);

  const splitIntoChunks = (coords, maxPoints = 23) => {
    const chunks = [];
    for (let i = 0; i < coords.length - 1; i += maxPoints - 1) {
      const chunk = coords.slice(i, i + maxPoints);
      if (chunk.length < 2) break;
      chunks.push(chunk);
    }
    return chunks;
  };
  const fetchVehicleData = async (date = selectedDate) => {
    try {
      setLoading(true);
      setNoTrackingMessage("");
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vehicle-history/${id}/${date}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const locationData = response.data.vehicleHistory || [];
      if (locationData.length > 0) {
        setVehicleNumber(locationData[0].vehicleNumber || "Unknown Vehicle");

        const hubs = locationData[0].id_vehicle?.id_hub || [];
        const names = hubs.map((hub) => hub.name).filter(Boolean);
        setHubNames(names);
      }

      if (!locationData.length) {
        setPathCoordinates([]);
        setTotalDistance(0);
        setNoTrackingMessage("NO TRACKING AVAILABLE FOR TODAY");
        return;
      }

      // ✅ Sort data by lastDate ascending (oldest → newest)
      const sortedData = [...locationData].sort(
        (a, b) => new Date(a.lastDate) - new Date(b.lastDate)
      );

      // ✅ Detect first movement
      const firstMovement = sortedData.find(
        (rec) =>
          rec.vehicleStatus?.toLowerCase() === "running" ||
          parseFloat(rec.speed) > 0
      );

      if (firstMovement) {
        setFirstMovementTime(moment(firstMovement.lastDate).format("h:mm a"));
        if (
          firstMovement.coordinates?.latitude &&
          firstMovement.coordinates?.longitude
        ) {
          setFirstMovementCoords({
            lat: parseFloat(firstMovement.coordinates.latitude),
            lng: parseFloat(firstMovement.coordinates.longitude),
          });
        }
      } else {
        setFirstMovementTime(null);
        setFirstMovementCoords(null);
      }

      // ✅ Detect last movement
      const lastMovement = [...sortedData]
        .reverse()
        .find(
          (rec) =>
            rec.vehicleStatus?.toLowerCase() === "running" ||
            parseFloat(rec.speed) > 0
        );

      if (lastMovement) {
        setLastMovementTime(moment(lastMovement.lastDate).format("h:mm a"));

        // ✅ Instead of using `location` from API → decode latest coordinates
        if (
          lastMovement.coordinates?.latitude &&
          lastMovement.coordinates?.longitude
        ) {
          try {
            const res = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lastMovement.coordinates.latitude},${lastMovement.coordinates.longitude}&key=${process.env.REACT_APP_BASE_API}`
            );
            const data = await res.json();
            if (data.status === "OK" && data.results.length > 0) {
              setLastMovementLocation(data.results[0].formatted_address);
            } else {
              setLastMovementLocation("Address not found");
            }
          } catch (err) {
            console.error("Reverse geocoding error:", err);
            setLastMovementLocation("Error fetching address");
          }
        } else {
          setLastMovementLocation("No coordinates available");
        }
      } else {
        setLastMovementTime(null);
        setLastMovementLocation(null);
      }

      // ✅ Map coordinates in correct order
      const filteredCoordinates = sortedData
        .map((location) => {
          if (
            location.coordinates?.latitude &&
            location.coordinates?.longitude
          ) {
            return {
              lat: parseFloat(location.coordinates.latitude),
              lng: parseFloat(location.coordinates.longitude),
              locationName: location.location || "Unknown location",
            };
          }
          return null;
        })
        .filter(Boolean);

      setPathCoordinates(filteredCoordinates);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleData();
  }, []);

  useEffect(() => {
    if (pathCoordinates.length > 1) {
      fetchDirections(pathCoordinates);
    }
  }, [pathCoordinates]);

  const fetchDirections = async (coordinates) => {
    if (coordinates.length < 2) return;

    const chunks = splitIntoChunks(coordinates, 23);
    const directionsService = new window.google.maps.DirectionsService();
    const directionResults = [];
    let total = 0;

    for (const chunk of chunks) {
      const origin = chunk[0];
      const destination = chunk[chunk.length - 1];
      const waypoints = chunk.slice(1, -1).map((coord) => ({
        location: { lat: coord.lat, lng: coord.lng },
        stopover: false,
      }));

      await new Promise((resolve) => {
        directionsService.route(
          {
            origin,
            destination,
            waypoints,
            travelMode: window.google.maps.TravelMode.DRIVING,
          },
          (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              directionResults.push(result);

              const legs = result.routes[0].legs;
              legs.forEach((leg) => {
                total += leg.distance.value;
              });
            } else {
              console.error("Error fetching directions:", status);
            }
            resolve();
          }
        );
      });
    }

    setDirections(directionResults);
    setTotalDistance(total / 1000); // meters → km
  };

  const handleMarkerClick = (marker) => {
    setSelectedMarker(marker);
  };

  const handleInfoWindowCloseClick = () => {
    setSelectedMarker(null);
  };

  return (
    <>
      <Layouts />
      <div
        style={{
          position: "absolute",
          top: "13px",
          right: "70px",
          zIndex: 1000,
          background: "rgba(255, 255, 255, 0.25)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
          borderRadius: "8px",
          padding: "12px 24px",
          color: "#000",
          fontSize: "17px",
          fontWeight: "600",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
          transition: "all 0.3s ease",
          backgroundColor: "#f8b333ff",
        }}
      >
        {vehicleNumber && (
          <div
            style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "700" }}
          >
            🚘 Vehicle:{" "}
            <span style={{ color: "#1a237e" }}>{vehicleNumber}</span>
            {hubNames.length > 0 && (
              <span style={{ color: "#555" }}> ({hubNames.join(", ")})</span>
            )}
          </div>
        )}
        🚗 Total Distance:{" "}
        <span style={{ color: "#00796b" }}>{totalDistance.toFixed(2)} km</span>
        {firstMovementTime && (
          <div style={{ marginTop: "5px", fontSize: "15px" }}>
            🕒 First Movement:{" "}
            <span style={{ color: "#00796b" }}>{firstMovementTime}</span>
          </div>
        )}
        {/* {lastMovementTime && (
          <div style={{ marginTop: "5px", fontSize: "15px" }}>
            ⏳ Last Movement:{" "}
            <span style={{ color: "#d32f2f" }}>{lastMovementTime}</span>
          </div>
        )} */}
        {lastMovementTime && (
          <div style={{ marginTop: "5px", fontSize: "15px" }}>
            ⏳ Last Movement:{" "}
            <span style={{ color: "#d32f2f" }}>{lastMovementTime}</span>
            {lastMovementLocation && (
              <div
                style={{ marginTop: "3px", fontSize: "14px", color: "#333" }}
              >
                📍<b>Current Location:</b> {lastMovementLocation}
              </div>
            )}
          </div>
        )}
      </div>

      <LoadScript googleMapsApiKey={process.env.REACT_APP_BASE_API}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={pathCoordinates[0] || { lat: 30.7067034, lng: 76.6877915 }}
          zoom={12}
          onLoad={(map) => (mapRef.current = map)}
        >
          {loading ? (
            <div>Loading...</div>
          ) : noTrackingMessage ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#ffdddd",
                padding: "10px 20px",
                borderRadius: "10px",
                fontSize: "18px",
                fontWeight: "bold",
                color: "#d9534f",
              }}
            >
              {noTrackingMessage}
            </div>
          ) : (
            <>
              {pathCoordinates.length > 0 && (
                <OverlayView
                  position={pathCoordinates[pathCoordinates.length - 1]}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <div style={rippleStyle}></div>
                </OverlayView>
              )}

              {/* Marker for first movement */}
              {firstMovementCoords && (
                <Marker
                  position={firstMovementCoords}
                  icon={{
                    url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                  }}
                  title="First Movement of the Day"
                />
              )}

              {directions &&
                directions.map((dir, idx) => (
                  <DirectionsRenderer key={idx} directions={dir} />
                ))}

              {selectedMarker && (
                <InfoWindow
                  position={selectedMarker}
                  onCloseClick={handleInfoWindowCloseClick}
                >
                  <div>
                    <h4>{selectedMarker.locationName}</h4>
                    <p>
                      Coordinates: {selectedMarker.lat}, {selectedMarker.lng}
                    </p>
                  </div>
                </InfoWindow>
              )}
            </>
          )}
        </GoogleMap>
      </LoadScript>
    </>
  );
}
